import React from 'react';
import { connect } from 'react-redux';
import { Form, Field, reduxForm, SubmissionError, reset } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import {
  RenderTextField as TextField
} from '../formInputs';

import Message from '../components/Message';
/* import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import { required } from '../../utils/validations'; */
import { updateTravelGUserPassword } from '../redux/modules/user/action';

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: theme.palette.error.dark,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  title: {
    marginTop: 10,
  }
});

class TravelGUpdatePassword extends React.Component {
  state = {
    message: null
  };

  updatePassword = (props) => {
    const { dispatch, match } = this.props;

    if (props.password !== props.confirmPassword) {
      throw new SubmissionError({ 
        confirmPassword: 'Password Do not match' 
      });
    }

    dispatch(updateTravelGUserPassword(props, match.params.id))
      .then(() => {
        this.setState({ message: 'Password Updated'});
        dispatch(reset('updatePassword'));
      })
      .catch((e) => this.setState({ error: e.message }));
  }

  close = () => {
    this.setState({
      message: null,
      error: null
    });
  }

  render() {
    const { classes, handleSubmit } = this.props;
    const { message, error } = this.state;

    return (
      <main className={classes.main}>
        <Paper className={classes.paper}>

        { message && 
          <Message message={message} isOpen={message ? true : false } close={() => this.close()}/>
        }

        <Typography variant="h5" className={classes.title}>Update Password</Typography>
        <Form className={classes.form} onSubmit={handleSubmit(this.updatePassword)}>
          <FormControl margin="normal" fullWidth>
            <Field name="password" type="password" component={TextField} label="New Password" required />
          </FormControl>

          <FormControl margin="normal" fullWidth>
            <Field name="confirmPassword" type="password" component={TextField} label="Confirm Password" required />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Update Password
          </Button>

          {
            error && <p className={classes.error}>{error}</p>
          }
        </Form>
        </Paper>
      </main>
    )
  }
}

export default connect()(reduxForm({
  form: 'updatePassword'
})(withStyles(styles)(TravelGUpdatePassword)));